<template>
    <div>
        <div v-if="timedOut">
            <div class="overlay">
                <img src="../assets/Clock.svg" width="75">
                <h1>Die Zeit ist abgelaufen</h1>
                <span class="button" @click="nextQuestion">Weiter</span>
            </div>
        </div>
        <div v-else>
            <h1 class="question">{{question.question}}</h1>
            <div class="answers">
                <div v-for="(answer,id) in question.answers" :key="id">
                    <answer @click="onClick" :answer="answer" :clickable="clickable"></answer>
                </div>
            </div>
            <div class="timer-container" v-if="showTimer">
                <timer :time="40" @done="timeOver"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Timer from "./Timer";
    import Answer from "./Answer";

    export default {
        name: "Question",
        data() {
            return {
                showTimer: true,
                clickable: true,
                timedOut: false
            }
        },
        components: {Answer, Timer},
        props: ['question', 'counter'],
        methods: {
            onClick(correct) {
                this.clickable = false;
                this.showTimer = false;
                this.$emit('answered', correct);
            },
            timeOver() {
                this.timedOut = true;
                this.showTimer = false;
            },
            nextQuestion() {
                this.$emit('abort', 0);
            }
        }
    }
</script>

<style scoped lang="scss">
    $red: #B71E3F;
    $blue: #002438;

    div {
        color: white;
    }

    h1.question {
        height: 150px;
        overflow: visible;
    }

    .answers {
        display: flex;
        flex-wrap: wrap;
        width: 880px;
        justify-content: space-between;
        margin: auto;
    }


    .timer-container {
        position: absolute;
        right: 50px;
        top: 500px;
        width: 224px;
        height: 300px;
        z-index: 1;
    }
    .overlay {
        background-color: white;
        padding: 60px;
        color: #B71E3F;
        width: 1020px;
        margin: auto;
        h1 {
            margin-bottom: 60px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Question.vue